import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { BodySecondary, Caption, H5, H6 } from '@liveauctioneers/hammer-ui-core/text';

import useWindowSize from '@/hooks/useWindowSize';
import { useAppSelector } from '@/redux/hooks';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getManageCategoryNotificationsUrl } from '@/utils/urls';

import { TableRow } from './TableRow';

export const ManageCategoryNotifications = () => {
    const formatMessage = useAppFormatMessage();

    const bidderEmail = useAppSelector(getBidderEmail);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = mergedCaterwaulAndHammerUIThemes;

    return (
        <TableRow
            className="smMax:[&>:nth-child(1)]:grid-cols-[1/5]"
            email={
                <Link
                    href={getManageCategoryNotificationsUrl(bidderEmail)}
                    target="_blank"
                >
                    {formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'link'])}
                </Link>
            }
            frequency={
                width > tabletNarrowWidthNum &&
                formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'frequency'])
            }
            type={
                <>
                    {width > tabletNarrowWidthNum ? (
                        <H5>{formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'title'])}</H5>
                    ) : (
                        <H6>{formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'title'])}</H6>
                    )}
                    {width <= tabletNarrowWidthNum ? (
                        <Caption>
                            {formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'description'])}
                        </Caption>
                    ) : (
                        <BodySecondary color="secondary">
                            {formatMessage(['notificationsPage', 'table', 'managePreferencesRow', 'description'])}
                        </BodySecondary>
                    )}
                </>
            }
        />
    );
};
